module.exports = __webpack_public_path__ + "static/jimmy-wales-3a62d4e6c02f3314900073746a9cb8d7.jpg";